import Carousel from 'pinar';
import Banner from './Components/Banner/Banner';
import {Colors} from '../../../../constants/Colors';
import React, {useCallback, useEffect, useState} from 'react';
import CampaignsService from '../../../../services/CampaignsService/CampaignsService';
import {ActivityIndicator, View, useWindowDimensions} from 'react-native';
import {useUserStore} from '../../../../store/UserStore';
import {useIsDesktop} from '../../../../hooks/useIsDesktop';

const BANNER_ASPECT_RATIO = 16 / 9;
const DESKTOP_MAX_BANNER_HEIGHT = 430;

const commonDotStyle = {
  width: 10,
  height: 10,
  borderRadius: 50,
  marginRight: 10,
  marginBottom: -8,
};

const styles = {
  slide: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
    marginVertical: 10,
  },
  image: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  text: {
    color: '#444',
    opacity: 0.7,
    fontSize: 24,
    fontWeight: 'bold',
    position: 'absolute',
    bottom: 20,
    left: 20,
  },
  controlsButton: {
    backgroundColor: Colors.RedPallete.red,
    padding: 10,
    borderRadius: 5,
  },
  dotStyle: {
    ...commonDotStyle,
    backgroundColor: Colors.GrayPallete.lightGrayFour,
  },
  activeDotStyle: {
    ...commonDotStyle,
    backgroundColor: Colors.RedPallete.red,
  },
};

const fetchData = async (audience: {subchannel: string; figure: string}) => {
  try {
    const response = await CampaignsService.bannersDataGet(audience);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export default ({catalogData}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const isDesktop = useIsDesktop();
    const { width } = useWindowDimensions();
    const carouselHeight = isDesktop
      ? Math.min(Math.round(width / BANNER_ASPECT_RATIO), DESKTOP_MAX_BANNER_HEIGHT)
      : 236;

    // UserStore, não AuthStore: na troca de empresa de usuário não-rede só o
    // UserStore é atualizado, e o filtro usava o subcanal da empresa do login.
    const {user} = useUserStore();
    const currentClient = (user as any)?.current_client;
    const subchannel = String(currentClient?.subchannel ?? '').trim();
    const figure = String(currentClient?.figure ?? '').trim();

    const loadData = useCallback(async () => {
      setLoading(true);
      // O backend já filtra (antes de paginar); o filtro local cobre backend
      // ainda sem o deploy. Lista vazia = todos; subcanal E figura precisam bater.
      const storedData = await fetchData({subchannel, figure});
      const matches = (list: unknown, value: string) =>
        !Array.isArray(list) ||
        list.length === 0 ||
        (value !== '' && list.map(v => String(v).trim()).includes(value));

      const filteredData = storedData?.filter(
        item =>
          matches(item?.subchannels, subchannel) &&
          matches(item?.figures, figure),
      );

      setData(filteredData);
      setLoading(false);
    }, [subchannel, figure]);
  
    useEffect(() => {
      loadData();
    }, [loadData]);
  
    if (loading) {
      return <ActivityIndicator size="large" color={Colors.RedPallete.red} />;
    }
  
    return (
      <>
        {data && data.length > 0 ? (
          <View style={{ height: carouselHeight + 28 }}>
            <Carousel
              autoplay
              loop
              showsControls={false}
              controlsButtonStyle={styles.controlsButton}
              dotStyle={styles.dotStyle}
              activeDotStyle={styles.activeDotStyle}>
              {data.map((item, index) => (
                <Banner key={index} {...item} catalogData={catalogData} />
              ))}
            </Carousel>
          </View>
        ) : null}
      </>
    );
  };
  